import { Match } from 'effect';
import * as O from 'fp-ts/Option';
import { pipe } from 'fp-ts/lib/function';
import { iso } from 'newtype-ts';
import { ProductId } from '../api/productId';
import { hasProp } from '../hasProp';
const _ = iso();
export const raw = (p) => _.unwrap(p);
export const id = (p) => {
    return _.unwrap(p).id;
};
export const name = (p) => _.unwrap(p).name;
export const image = (p) => _.unwrap(p).image;
export const price = (p) => _.unwrap(p).price;
export const currency = (p) => _.unwrap(p).currency;
export const placement = (p) => _.unwrap(p).placement;
export const properties = (p) => _.unwrap(p).properties;
export const configurableProperties = (p) => _.unwrap(p).configurableProperties;
export const groupingCode = (p) => _.unwrap(p).groupingCode;
export const productUrl = (p) => _.unwrap(p).productUrl;
export const productType = (p) => _.unwrap(p).productType;
export const originalPrice = (p) => pipe(p, _.unwrap, _p => _p.originalPrice, O.fromNullable);
export const construct = (p) => _.wrap({ ...p, id: ProductId.make(p.id), tag: 'Product' });
export const getPlacement = (properties) => {
    return Match.value({
        atFloor: properties['attached to floor'],
        atWall: properties['attached to wall'],
    }).pipe(Match.when({ atFloor: true, atWall: true }, _ => 'WallAndFloor'), Match.when({ atFloor: true }, _ => 'Floor'), Match.when({ atWall: true }, _ => 'Wall'), Match.orElse(() => 'OtherProduct'));
};
export const fromApi = (p) => construct({
    id: ProductId.make(p.canonicalId),
    name: p.name,
    articles: p.kind === 'simple' ? p.articles : {},
    image: p.thumbnailUrl,
    price: p.price.saleValue ?? p.price.value,
    currency: p.price.currency,
    originalPrice: p.price.saleValue ? p.price.value : undefined,
    placement: p.productPlacement ?? 'OtherProduct',
    productUrl: p.productUrl,
    productType: p.productType,
    groupingCode: p.kind === 'simple' && p.groupingCode ? p.groupingCode : undefined,
    properties: p.properties,
    configurableProperties: p.kind === 'simple' ? p.configurableProperties : undefined,
    kind: p.kind,
});
export const is = (u) => {
    if (typeof u === 'object' && u !== null && hasProp(u, 'tag')) {
        return u.tag === 'Product';
    }
    return false;
};
export const getModelUrl = (serviceUrls, product) => `${serviceUrls.ar}/${encodeURIComponent(id(product))}.glb`;
export const getUSDZModelUrl = (serviceUrls, product) => `${serviceUrls.ar}/${encodeURIComponent(id(product))}.usdz`;
export const getHandedness = (properties) => {
    function isHandedness(value) {
        return ['left', 'right', 'none', 'reversible'].includes(value);
    }
    if ('handedness' in properties && typeof properties['handedness'] === 'string') {
        const handednessValue = properties['handedness'];
        if (isHandedness(handednessValue)) {
            return handednessValue;
        }
    }
    return undefined;
};
export const updateProperties = (product, newProperties) => {
    const raw = _.unwrap(product);
    raw.properties = newProperties;
    return _.wrap(raw);
};
